import { getApiBaseUrl } from '../../../utils/apiConfig';

function authHeaders() {
  const token = typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;
  return {
    Authorization: token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
  };
}

/** Busca sugestões de endereço (Google Places via backend). */
export async function searchOrderAddress(query) {
  const q = String(query || '').replace(/\s+/g, ' ').trim();
  if (q.length < 4) return [];
  const res = await fetch(
    `${getApiBaseUrl()}/api/maps/address-search?q=${encodeURIComponent(q)}`,
    { headers: authHeaders() }
  );
  const data = await res.json().catch(() => null);
  if (!data || !data.success) return [];
  return Array.isArray(data.items) ? data.items : [];
}

/** Resolve placeId → campos parseados (logradouro, número, etc.). */
export async function resolveOrderAddress(item, query = '') {
  if (item && item.parsed && (item.display || item.texto)) return item;
  const placeId = item && item.placeId;
  if (!placeId) return item || null;
  const res = await fetch(
    `${getApiBaseUrl()}/api/maps/address-details?placeId=${encodeURIComponent(placeId)}&q=${encodeURIComponent(query || '')}`,
    { headers: authHeaders() }
  );
  const data = await res.json().catch(() => null);
  if (!data || !data.success) return item || null;
  return data.item || item;
}

/** PATCH endereço da OS. */
export async function patchOrderAddress(orderNumber, payload) {
  const res = await fetch(`${getApiBaseUrl()}/api/orders/${encodeURIComponent(orderNumber)}/address`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao atualizar endereço');
  }
  return json.data;
}

/** PATCH localização interna da OS. */
export async function patchOrderLocalizacao(orderNumber, localizacao) {
  const res = await fetch(`${getApiBaseUrl()}/api/orders/${encodeURIComponent(orderNumber)}/localizacao`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify({ localizacao }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao atualizar localização');
  }
  return json.data;
}
